import React, { CSSProperties, useState, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { useInfoFetch } from '../../hooks/useInfoFetch';
import { selectMobileSections, selectDesktopSections } from '../../features/infoSlice';
import { useSelector } from 'react-redux';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { mockContactContent } from '../../mock/data';
import { JsxElement } from 'typescript';
import { ContactSection } from '../../types/_base';

interface InfoBoxProps {
  name: string;
  content: React.ReactNode;
  className?: string; // Optional additional className
  style?: CSSProperties; // Optional inline styles
}

export const InfoBox = ({ name, content, className = '', style = {} }: InfoBoxProps) => {
  const isEmpty = content === '';
  // Combine the base className with any additional className passed as a prop
  const baseClassName = isEmpty ? 'info-box hidden md:block' : 'info-box';
  const combinedClassName = `${baseClassName} ${className}`.trim();
  const bodyContent = typeof content === 'string' ? 
    <div dangerouslySetInnerHTML={{ __html: content }} /> :
    content; 

  return (
    <div className={combinedClassName} style={style}>
      {name && <h2>{name}</h2>}
      {bodyContent}
    </div>
  );
};

export const ArchiveLink = () => {
  return (
    <NavLink to={'/archive'} className='underline underline-offset-8'>
      Older works (2010 &mdash; 2020)
    </NavLink>
  )
}

// interface ContactPageProps {
//   studioContact: ContactSection;
//   galleryContact: ContactSection;
//   agentContact: ContactSection;
//   commercialClients: ContactSection;
//   editorialClients: ContactSection;
// }
interface ContactPageProps { contactSections: ContactSection[]; }

export const MobileContactContent = (props: ContactPageProps) => {
  // const { studioContact, galleryContact, agentContact, commercialClients, editorialClients } = props;
  const { contactSections } = props;

  const infoBoxStyles: CSSProperties = {
    textAlign: 'left',
    padding: '0',
    marginBottom: '4rem',
  }

  const gridStyles: CSSProperties = { padding: '0 1rem' }

	return (
    <div className="info-row" style={gridStyles}>
      {contactSections.map((section, index) => {
        const { name, content } = section;
        return (
          <InfoBox key={index} name={name} content={content} style={infoBoxStyles} />
        )
      })}
      <InfoBox name=""  content={<ArchiveLink />} style={infoBoxStyles} />
    </div>
	)
}

export const LargeContactContent = (props: ContactPageProps) => {
  // const { studioContact, galleryContact, agentContact, commercialClients, editorialClients } = props;
  const { contactSections } = props;

  const gridStyles: CSSProperties = {
    columnGap: '2.380952381vw',
    padding: '0 2.380952381vw',
  }

	return (
    <div className="info-row" style={gridStyles}>
      {contactSections.map((section, index) => {
        const { name, content } = section;
        if (index % 2 !== 0) {
          return (
            <>
              <InfoBox key={index} name={name} content={content} />
              <div>&nbsp;</div>
            </>
          )
        } else {
          return (
            <InfoBox key={index} name={name} content={content} />
          )
        }
      })}
      <InfoBox name=""  content={<ArchiveLink />} />
      <div>&nbsp;</div>
    </div>
	)
}

const ContactPage = () => {
  const { contactSections, data, error, isLoading } = useInfoFetch();
  const mobileSections  = useSelector(selectMobileSections);
  const desktopSections = useSelector(selectDesktopSections);

	return (
    <>
      <div className='info-outer small-version'>
        <MobileContactContent contactSections={mobileSections} />
      </div>
      
      <div className='info-outer large-version'>
        <LargeContactContent contactSections={desktopSections} />
      </div>
    </>
	)
}

export default ContactPage